/** Intent routing for the B2C rebooking picker (PLA-878 / PLA-882). */

export type PickerIntent = "reschedule" | "cancel" | "noshow" | "cancelled"
export type RecoveryIntent = Extract<PickerIntent, "noshow" | "cancelled">

const NO_SHOW_STATUSES = ["no_show", "709823443"]
const CANCELLED_STATUSES = ["cancelled", "3552907480"]

export const PICKER_INTENTS = ["reschedule", "cancel", "noshow", "cancelled"] as const

export function isRecoveryIntent(intent: PickerIntent): intent is RecoveryIntent {
  return intent === "noshow" || intent === "cancelled"
}

/**
 * Picker intent for a no_show / cancelled order from a b2c-website source, else
 * null (FleetHub, OrbitControl, unknown source keep the widget popup).
 * Accepts the string statuses and the raw HubSpot stage ids.
 */
export function pickerIntentForStatus(
  status: string | undefined | null,
  orderSource: string | undefined | null,
): RecoveryIntent | null {
  if (!status || !orderSource?.startsWith("b2c-website")) return null
  if (NO_SHOW_STATUSES.includes(status)) return "noshow"
  if (CANCELLED_STATUSES.includes(status)) return "cancelled"
  return null
}
